import { useRef } from 'react'

type UnifiedTapEv = React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement> | React.MouseEvent<HTMLButtonElement>

export function useUnifiedTap<T extends unknown[] = []>(handler?: (ev: UnifiedTapEv, ...args: T) => void) {
    const state = useRef({
        startX: 0,
        startY: 0,
        startTime: 0,
        moved: false
    })

    const MOVE_THRESHOLD = 10
    const TIME_THRESHOLD = 200

    return {
        onTouchStart: (e: React.TouchEvent, ..._args: T) => {
            const t = e.touches[0]
            state.current.startX = t.clientX
            state.current.startY = t.clientY
            state.current.startTime = Date.now()
            state.current.moved = false
        },

        onTouchMove: (e: React.TouchEvent, ..._args: T) => {
            const t = e.touches[0]
            const dx = Math.abs(t.clientX - state.current.startX)
            const dy = Math.abs(t.clientY - state.current.startY)
            if (dx > MOVE_THRESHOLD || dy > MOVE_THRESHOLD) {
                state.current.moved = true
            }
        },

        onTouchEnd: (e: React.TouchEvent<HTMLElement>, ...args: T) => {
            if (!handler) {
                return
            }
            const duration = Date.now() - state.current.startTime
            if (!state.current.moved && duration < TIME_THRESHOLD) {
                handler(e, ...args)
            }
        },

        // 🖥 PC 端
        onClick: (e: React.MouseEvent<HTMLElement>, ...args: T) => {
            if (!handler || 'ontouchstart' in window) return
            handler(e, ...args)
        }
    }
}
